import AbstractRuleTemplateAction from "./AbstractRuleTemplateAction.js";

/**
 * Action to perform in order to add a new rule template
 */
export default class AddRuleTemplateAction extends AbstractRuleTemplateAction {
	appendTo(bulkRuleTemplateAction) {
		bulkRuleTemplateAction.appendAddRuleAction({
			ruleTemplate: this._ruleTemplate,
		});
	}
}
